import { Action } from '@ngrx/store';
import { ErgoRoleInterface } from 'app/role/models/ergo-role.model';
import { RoleInterface } from 'app/role/models/role.model';

import { RoleActionType } from './role-actions.enum';

export class LoadRoles implements Action {
  public readonly type: RoleActionType = RoleActionType.LoadRoles;

  public readonly payload: any = undefined;
}

export class LoadRolesComplete implements Action {
  public readonly type: RoleActionType = RoleActionType.LoadRolesComplete;

  constructor(public readonly payload: RoleInterface[]) {}
}

export class LoadRolesFailed implements Action {
  public readonly type: RoleActionType = RoleActionType.LoadRolesFailed;

  constructor(public readonly payload: string) {}
}

export class LoadErgoRoles implements Action {
  public readonly type: RoleActionType = RoleActionType.LoadErgoRoles;

  public readonly payload: any = undefined;
}

export class LoadErgoRolesComplete implements Action {
  public readonly type: RoleActionType = RoleActionType.LoadErgoRolesComplete;

  constructor(public readonly payload: ErgoRoleInterface[]) {}
}

export class LoadErgoRolesFailed implements Action {
  public readonly type: RoleActionType = RoleActionType.LoadErgoRolesFailed;

  constructor(public readonly payload: string) {}
}

